export const widgetStyles = `
  html, body {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: #18181b;
    box-sizing: border-box;
    background: transparent;
    -webkit-font-smoothing: antialiased;
  }

  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  .br-fab {
    display: none !important;
  }

  .br-panel {
    position: fixed;
    top: 0;
    right: 0;
    width: 420px;
    max-width: 100vw;
    height: 100vh;
    background: #ffffff;
    z-index: 2147483647;
    transform: translateX(100%);
    transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
    display: flex;
    flex-direction: column;
    box-shadow: -8px 0 32px rgba(0, 0, 0, 0.08);
    border-left: 1px solid #e4e4e7;
    pointer-events: auto;
  }

  .br-panel.open {
    transform: translateX(0);
  }

  .br-panel.mobile {
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100vw;
    max-width: 100vw;
    height: 100dvh;
    box-shadow: none;
    border: none;
    border-radius: 0;
    padding-top: env(safe-area-inset-top);
  }

  .br-panel-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    background: #fafafa;
    border-bottom: 1px solid #e4e4e7;
    flex-shrink: 0;
  }

  .br-panel-header h2 {
    font-size: 16px;
    font-weight: 600;
    color: #18181b;
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .br-panel.mobile .br-panel-header {
    min-height: 56px;
    padding: 12px 16px;
  }

  .br-panel.mobile .br-panel-header h2 {
    font-size: 15px;
  }

  .br-close-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #e4e4e7;
    background: #ffffff;
    color: #71717a;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    transition: all 0.2s;
  }

  .br-panel.mobile .br-close-btn {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .br-close-btn:hover {
    background: #f4f4f5;
    color: #18181b;
  }

  .br-panel-body {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
    -webkit-overflow-scrolling: touch;
  }

  .br-panel.mobile .br-panel-body {
    padding: 16px;
    padding-bottom: 24px;
  }

  .br-panel-body::-webkit-scrollbar {
    width: 6px;
  }

  .br-panel-body::-webkit-scrollbar-track {
    background: transparent;
  }

  .br-panel-body::-webkit-scrollbar-thumb {
    background: #d4d4d8;
    border-radius: 3px;
  }

  .br-field {
    margin-bottom: 16px;
  }

  .br-field label {
    display: block;
    font-size: 13px;
    font-weight: 500;
    color: #52525b;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .br-field label .br-required {
    color: #ef4444;
    margin-left: 2px;
  }

  .br-input,
  .br-select,
  .br-textarea {
    width: 100%;
    padding: 10px 12px;
    border-radius: 8px;
    border: 1px solid #e4e4e7;
    background: #ffffff;
    color: #18181b;
    font-size: 14px;
    font-family: inherit;
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
  }

  .br-panel.mobile .br-input,
  .br-panel.mobile .br-select,
  .br-panel.mobile .br-textarea {
    min-height: 44px;
    font-size: 16px;
    padding: 12px 14px;
  }

  .br-input:focus,
  .br-select:focus,
  .br-textarea:focus {
    border-color: #a1a1aa;
    box-shadow: 0 0 0 3px rgba(161, 161, 170, 0.15);
  }

  .br-input::placeholder,
  .br-textarea::placeholder {
    color: #a1a1aa;
  }

  .br-textarea {
    min-height: 80px;
    resize: vertical;
  }

  .br-select {
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%2371717a' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    padding-right: 36px;
    cursor: pointer;
  }

  .br-select option {
    background: #ffffff;
    color: #18181b;
  }

  .br-elements-section {
    margin-bottom: 16px;
  }

  .br-elements-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .br-elements-header span {
    font-size: 13px;
    font-weight: 500;
    color: #52525b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .br-elements-count {
    font-size: 11px;
    background: #18181b;
    color: white;
    padding: 2px 8px;
    border-radius: 10px;
    font-weight: 600;
  }

  .br-elements-list {
    list-style: none;
    border: 1px solid #e4e4e7;
    border-radius: 8px;
    overflow: hidden;
  }

  .br-element-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #fafafa;
    border-bottom: 1px solid #e4e4e7;
    font-size: 13px;
    font-family: 'SF Mono', 'Fira Code', monospace;
    color: #3f3f46;
    gap: 8px;
  }

  .br-element-item:last-child {
    border-bottom: none;
  }

  .br-element-remove {
    width: 24px;
    height: 24px;
    border-radius: 6px;
    border: none;
    background: rgba(239, 68, 68, 0.1);
    color: #ef4444;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    flex-shrink: 0;
    transition: background 0.2s;
  }

  .br-element-remove:hover {
    background: rgba(239, 68, 68, 0.2);
  }

  .br-element-selector {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-right: 8px;
  }

  .br-no-elements {
    padding: 16px;
    text-align: center;
    color: #a1a1aa;
    font-size: 13px;
    background: #fafafa;
    border-radius: 8px;
    border: 1px dashed #e4e4e7;
  }

  .br-screenshot-toggle {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: #fafafa;
    border-radius: 8px;
    border: 1px solid #e4e4e7;
    margin-bottom: 16px;
    cursor: pointer;
  }

  .br-panel.mobile .br-screenshot-toggle {
    min-height: 48px;
  }

  .br-toggle-switch {
    position: relative;
    width: 36px;
    height: 20px;
    border-radius: 10px;
    background: #d4d4d8;
    transition: background 0.2s;
    flex-shrink: 0;
  }

  .br-toggle-switch.active {
    background: #18181b;
  }

  .br-toggle-switch::after {
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    background: white;
    top: 2px;
    left: 2px;
    transition: transform 0.2s;
  }

  .br-toggle-switch.active::after {
    transform: translateX(16px);
  }

  .br-screenshot-label {
    font-size: 13px;
    color: #52525b;
  }

  .br-upload-section {
    margin-bottom: 16px;
    padding: 12px;
    border: 1px solid #e4e4e7;
    border-radius: 10px;
    background: #fcfcfd;
  }

  .br-upload-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
  }

  .br-upload-header span {
    font-size: 13px;
    font-weight: 500;
    color: #52525b;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .br-upload-count {
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 10px;
    color: #ffffff;
    background: #18181b;
  }

  .br-upload-trigger {
    position: relative;
    width: 100%;
    min-height: 42px;
    border: 1px solid #d4d4d8;
    border-radius: 9px;
    background: #ffffff;
    color: #27272a;
    font-size: 13px;
    font-weight: 600;
    font-family: inherit;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 12px;
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
  }

  .br-upload-trigger:hover {
    background: #f9fafb;
    border-color: #a1a1aa;
  }

  .br-upload-trigger.mobile {
    min-height: 50px;
    font-size: 15px;
  }

  .br-file-input {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
  }

  .br-upload-help {
    margin-top: 8px;
    font-size: 12px;
    color: #71717a;
  }

  .br-upload-error {
    margin-top: 8px;
    font-size: 12px;
    line-height: 1.4;
    color: #dc2626;
  }

  .br-upload-empty {
    margin-top: 10px;
    border: 1px dashed #d4d4d8;
    border-radius: 8px;
    padding: 10px;
    font-size: 12px;
    color: #a1a1aa;
    text-align: center;
  }

  .br-upload-chips {
    margin-top: 10px;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .br-upload-chip {
    display: flex;
    align-items: center;
    gap: 8px;
    border: 1px solid #e4e4e7;
    border-radius: 8px;
    padding: 6px 8px;
    background: #ffffff;
  }

  .br-upload-thumb {
    width: 34px;
    height: 34px;
    border-radius: 6px;
    object-fit: cover;
    background: #f4f4f5;
    border: 1px solid #e4e4e7;
    flex-shrink: 0;
  }

  .br-upload-name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: #3f3f46;
  }

  .br-upload-size {
    font-size: 11px;
    color: #71717a;
    white-space: nowrap;
  }

  .br-upload-remove {
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 6px;
    background: rgba(239, 68, 68, 0.1);
    color: #dc2626;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    cursor: pointer;
    flex-shrink: 0;
  }

  .br-upload-remove:hover {
    background: rgba(239, 68, 68, 0.2);
  }

  .br-advanced-toggle {
    width: 100%;
    padding: 10px 0;
    border: none;
    background: none;
    color: #71717a;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
    text-align: left;
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    transition: color 0.2s;
    font-family: inherit;
  }

  .br-advanced-toggle:hover {
    color: #18181b;
  }

  .br-advanced-toggle .br-chevron {
    transition: transform 0.2s;
    font-size: 10px;
  }

  .br-advanced-toggle.open .br-chevron {
    transform: rotate(90deg);
  }

  .br-advanced-content {
    display: none;
    margin-bottom: 16px;
  }

  .br-advanced-content.open {
    display: block;
  }

  .br-select-banner {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 14px;
    background: #f4f4f5;
    border: 1px solid #e4e4e7;
    border-radius: 8px;
    margin-bottom: 16px;
    font-size: 13px;
    color: #3f3f46;
  }

  .br-select-banner button {
    margin-left: auto;
    padding: 8px 12px;
    min-height: 36px;
    border-radius: 8px;
    border: 1px solid #d4d4d8;
    background: #ffffff;
    color: #3f3f46;
    cursor: pointer;
    font-size: 12px;
    font-family: inherit;
    transition: all 0.2s;
    white-space: nowrap;
  }

  .br-select-banner button:hover {
    background: #f4f4f5;
    border-color: #a1a1aa;
  }

  .br-mobile-selecting {
    background: transparent;
  }

  .br-panel.mobile.br-mobile-selecting {
    pointer-events: none;
  }

  .br-mobile-select-strip,
  .br-mobile-select-strip * {
    pointer-events: auto;
  }

  .br-mobile-select-strip {
    position: fixed;
    left: 12px;
    right: 12px;
    top: calc(env(safe-area-inset-top) + 10px);
    min-height: 44px;
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: space-between;
    padding: 8px 12px;
    border-radius: 12px;
    background: rgba(24, 24, 27, 0.94);
    color: #fafafa;
    font-size: 14px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.24);
  }

  .br-mobile-select-strip button {
    min-height: 32px;
    padding: 6px 10px;
    border-radius: 8px;
    border: none;
    background: #ffffff;
    color: #18181b;
    font-size: 12px;
    font-weight: 600;
    font-family: inherit;
  }

  .br-panel-footer {
    display: flex;
    gap: 10px;
    padding: 16px 20px;
    border-top: 1px solid #e4e4e7;
    background: #fafafa;
    flex-shrink: 0;
  }

  .br-panel-footer.mobile {
    position: sticky;
    bottom: 0;
    padding: 12px 16px calc(env(safe-area-inset-bottom) + 12px);
    background: rgba(250, 250, 250, 0.98);
    backdrop-filter: blur(4px);
  }

  .br-btn {
    padding: 10px 20px;
    min-height: 42px;
    border-radius: 8px;
    border: none;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;
    font-family: inherit;
    justify-content: center;
  }

  .br-panel.mobile .br-btn {
    min-height: 46px;
    font-size: 15px;
  }

  .br-btn-secondary {
    background: #ffffff;
    color: #52525b;
    border: 1px solid #e4e4e7;
    flex: 1;
  }

  .br-btn-secondary:hover {
    background: #f4f4f5;
    border-color: #d4d4d8;
  }

  .br-btn-primary {
    background: #18181b;
    color: white;
    flex: 1;
  }

  .br-btn-primary:hover {
    background: #27272a;
  }

  .br-btn-primary:active {
    background: #09090b;
  }

  .br-btn-primary:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  .br-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.08);
    z-index: 2147483645;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s;
  }

  .br-overlay.active {
    opacity: 1;
  }

  .br-success {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 40px;
    text-align: center;
    height: 100%;
  }

  .br-success-icon {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    background: linear-gradient(135deg, #22c55e, #16a34a);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 32px;
    margin-bottom: 20px;
    animation: br-pop 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  }

  @keyframes br-pop {
    0% { transform: scale(0); }
    50% { transform: scale(1.2); }
    100% { transform: scale(1); }
  }

  .br-success h3 {
    font-size: 18px;
    font-weight: 600;
    color: #18181b;
    margin-bottom: 8px;
  }

  .br-success p {
    font-size: 14px;
    color: #71717a;
    margin-bottom: 24px;
  }

  .br-spinner {
    width: 20px;
    height: 20px;
    border: 2px solid #e4e4e7;
    border-top-color: #18181b;
    border-radius: 50%;
    animation: br-spin 0.6s linear infinite;
  }

  @keyframes br-spin {
    to { transform: rotate(360deg); }
  }

  .br-error {
    font-size: 12px;
    color: #ef4444;
    margin-top: 4px;
  }

  .br-input.invalid,
  .br-textarea.invalid,
  .br-select.invalid {
    border-color: #ef4444;
  }

  .br-token-prompt {
    position: fixed;
    z-index: 2147483645;
    pointer-events: auto;
  }

  .br-signout {
    display: inline-block;
    margin: 12px 0 16px 0;
    font-size: 11px;
    color: #a1a1aa;
    cursor: pointer;
    background: none;
    border: none;
    padding: 4px 8px;
    text-decoration: underline;
    font-family: inherit;
  }

  .br-mobile-signout-wrap {
    text-align: center;
    margin-top: 8px;
  }

  .br-signout:hover {
    color: #18181b;
  }
`;
